/** POST that answers with a file (PDF, QR PNG) — returned as an object URL. Same auth headers as
 *  apiRequest; the caller revokes the URL when it's done with it. */
export async function postForBlob(path: string, body: unknown): Promise<string> {
    const token = localStorage.getItem("token");
    const praxisId = JSON.parse(localStorage.getItem("praxis") || "null")?.id;
    const doctorId = JSON.parse(localStorage.getItem("doctor") || "null")?.id;
    const { config } = await import("configs/config");
    const res = await fetch(`${config.baseUrl}/api${path}`, {
        method: "POST",
        cache: "no-store",
        headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
            ...(doctorId && { "X-Doctor-Id": doctorId }),
            ...(praxisId && { "X-Praxis-Id": praxisId }),
        },
        body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`${path} ${res.status}`);
    return URL.createObjectURL(await res.blob());
}
